// extracted by mini-css-extract-plugin
module.exports = {"header":"MainHeader_header__2ElgL","cta":"MainHeader_cta__2D7vF"};